/**
 * Apple App Store Guideline 3.1.1 / 3.1.3(c): any payment / subscription /
 * pricing / self-serve signup UI shown inside the native iOS app must either
 * use Apple's In-App Purchase or not exist at all. We choose the second option
 * — Whapiz CRM is a B2B tool sold only to organizations; the company owner
 * pays on whapiz.com, employees just use the app.
 *
 * Detection MUST NOT be able to fail "open" (i.e. fall back to web mode and
 * expose payment UI) inside the iOS WebView. Earlier builds relied solely on
 * the runtime-injected window.Capacitor global, which is injected by the
 * native bridge AFTER the page starts loading — on a remote-URL app this is a
 * first-paint race, and if React rendered before the bridge appeared the
 * payment UI was shown. Apple's reviewer hit exactly this.
 *
 * The race-proof primary signal is the User-Agent: the native shell appends
 * "WhapizCRM-Native" to the WebView User-Agent (capacitor.config.json
 * appendUserAgent), so it is present on the very first request — before any
 * JS runs. The Capacitor bridge is kept as a secondary signal. We OR the
 * signals so any one of them is enough; we only return false when NONE match
 * (a real browser). This file intentionally has NO @capacitor/core import so
 * it behaves identically whether built from main (prod web) or the app branch.
 */
export const isNativeApp = () => {
  if (typeof window === "undefined") return false;

  // Primary, race-proof: custom User-Agent marker set by the native shell.
  try {
    const ua = (window.navigator && window.navigator.userAgent) || "";
    if (ua.indexOf("WhapizCRM-Native") !== -1) return true;
  } catch (_e) {
    /* ignore */
  }

  // Secondary: Capacitor runtime bridge (may be injected after first paint).
  const cap = window.Capacitor;
  if (cap) {
    if (typeof cap.isNativePlatform === "function") {
      try {
        if (cap.isNativePlatform()) return true;
      } catch (_e) {
        /* ignore */
      }
    }
    if (cap.isNative) return true;
  }

  return false;
};

export default isNativeApp;
